import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import ChoseWordLang from "../ChoseWordLang";
import ResSearchWorld from "../ResSearchWorld";
import axios from "axios";
import Answer from "../BlankSingle/Answer";
import classnames from "classnames";
import QuestionType from "../BlankType/QuestionAuto";
import { useDispatch, useSelector } from "react-redux";
import { setTitle, setValidation } from "../../../redux/action/user";
import { BaseUrl } from "../../../Constant/Config";
import { useHistory } from "react-router";
import { setEditTitle, setEditOption } from "../../../redux/action/Edit";
import {
  setCorrectAnswer,
} from "../../../redux/action/user";
//  Answer
import BlankAnswer from "../BlankSingle/TestAnswerBlank"

const Multicoice = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const EditState = useSelector((state) => state.Edit);
  const [loadingModal, setLoadingModal] = useState(true);
  const [blankFromApi, setBlankFromApi] = useState();
  const [chooseLang, setChooseLang] = useState("fa");
  const [langFa, setLangefa] = useState();
  const [langEng, setLangEng] = useState();
  const [wordList, setWordList] = useState([]);
  const [onChangeHeader, setonChangeHeader] = useState(
    EditState.edit && EditState.title ? EditState.title : ""
  );
  const [callValue, setCallValue] = useState(1);
  const [addAnswer, setAddAnswer] = useState(
    EditState.edit && EditState.option
      ? EditState.option
      : [<Answer callValue={1} testClick={() => addAnswerHandler()} />]
  );

  ////////////////////////////////// Answer
  const [answerArray, setAnswerArray] = useState(EditState.edit && EditState.option ? EditState.option : [{ title: "", id: 1, correct: false }])
  const AddAnswer = () => {
    let PreviousItem = answerArray[answerArray.length - 1]
    setAnswerArray(answerArray => [...answerArray, { title: "", id: PreviousItem ? PreviousItem.id + 1 : 1, correct: false }])
    dispatch(setCorrectAnswer(answerArray));
  }
  const DeleteAnswer = (title, id) => {
    if (EditState.edit) {
      if (answerArray.length > 1) {
        let ArrayAfterDelete = answerArray.filter(Answer => Answer._id !== id)
        setAnswerArray(ArrayAfterDelete)
      }
    } else {
      if (answerArray.length > 1) {
        let ArrayAfterDelete = answerArray.filter(Answer => Answer.id !== id)
        setAnswerArray(ArrayAfterDelete)
      }
    }

  }

  useEffect(() => {
    dispatch(setCorrectAnswer(answerArray));
    EditState.edit && dispatch(setEditOption(answerArray));

  }, [answerArray])





  let test;
  const addAnswerHandler = (value) => {
    setCallValue(callValue + 1);
    setAddAnswer([...addAnswer, test]);
    EditState.edit && dispatch(setEditOption([...EditState.option, { title: "", correct: false }]))
  };
  const handleChangeHeader = (e, value) => {
    EditState.edit && dispatch(setEditTitle(e.target.value));
    setonChangeHeader(e.target.value);
    dispatch(setTitle(e.target.value));
  };

  const getWordList = () => {
    axios
      .get(
        `${BaseUrl}/admin/word/list?api_token=${localStorage.getItem("token")}`
      )
      .then((res) => {
        setWordList(res.data.data);
      })
      .catch((error) => {
        return error?.response?.data?.status === 401
          ? history.push("/login")
          : null;
      });
  };
  useEffect(() => {
    getWordList();
  }, []);

  const deleteaddAnswerHandler = (e) => {
    // alert("lll");
    // if (EditState.edit) {
    //   dispatch(
    //     setEditOption(
    //       EditState.option.filter(
    //         (item) => item.title !== EditState.option[e].title
    //       )
    //     )
    //   );
    //   console.log(
    //     EditState.option,
    //     "optionnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn splice"
    //   );
    //   console.log(
    //     EditState.option,
    //     "optionnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn array"
    //   );
    //   setAddAnswer(EditState.option);
    // } else {
      EditState.edit && EditState.option && EditState.option.splice(e, 1)
    setAddAnswer(addAnswer.splice(e, 1));
    setAddAnswer([...addAnswer]);


    // }
  };

  const classCloseButton = "classTest";

  const answerVlue = props?.item?.answer[0].option;
  console.log(addAnswer,"asdasdasd")
  return (
    <div className="col-12  blank-main multi-choies">
      <div className="col-12 text-right header-type d-flex align-items-center justify-content-between mb-5">
        <TextField
          variant="filled"
          id="standard-basic "
          value={onChangeHeader}
          label={<p>عنوان سوال</p>}
          onChange={handleChangeHeader}
          autoComplete="off"
        />
      </div>
      <div className="col-12 my-5 text-right d-md-flex justify-content-between align-items-center p-0 ">
        <p className="m-0">
          کلمات مورد نظر رو به ترتیب برای عنوان سوال انتخاب کنید و جای خالی رو
          مشخص کنید
        </p>

        <ChoseWordLang setWordList={setWordList} />
      </div>
      <div className="col-12 p-0 mb-5 mt-4">
        <QuestionType Words={wordList} type="Multi" answerinapi={props.item} />
      </div>
      <div className=" text-right p-0 style-answer-responsev">
        <p>پاسخ های خود را وارد کنید و گزینه درست را انتخاب کنید </p>
      </div>
      <div className="col-12 p-0 box-answer d-flex justify-content-end">
        <div className="add-div-answer p-0 col-md-6 float-left style-answer-responsev">
           {
              answerArray &&
              answerArray.map((item, index) => {
                return (
                  <BlankAnswer
                    title={item.title}
                    index={index}
                    correct={item.correct}
                    answerArray={answerArray}
                    setAnswerArray={setAnswerArray}
                    DeleteAnswer={DeleteAnswer}
                    id={EditState.edit ? item._id : item.id}
                  />
                )
              })
            }
            {
              answerArray.length < 4 &&
              <div className="col-12">
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="border w-75 py-2 text-center rounded mb-3 pointer"
                    onClick={AddAnswer}
                  >
                    <span className="w-100 text_bold ">افزودن پاسخ جدید +</span>
                  </div>
                </div>
              </div>
            }
          {/* {answerVlue && (answerVlue === undefined || answerVlue === []) ? (
            addAnswer && addAnswer?.length > 3 ? null : (
              <button
                type="botton"
                onClick={(item) => {
            
                  return addAnswer !== undefined && addAnswer.length < 3
                    ? addAnswerHandler(callValue)
                    : null;
                }}
              >
                <span>+</span> افزودن پاسخ جدید
              </button>
            )
          ) : answerVlue.length > 3 ? null : (
            <button
              type="botton"
              onClick={(item) => {
                return addAnswer?.length > 3
                  ? null
                  : addAnswerHandler(callValue);
              }}
            >
              <span>+</span> افزودن پاسخ جدید
            </button>
          )} */}
          {/* {addAnswer && addAnswer?.length > 3 ? null : (
            <button
              type="botton"
              className="add-class-style-button-add"
              onClick={(item) => {
                return addAnswer !== undefined && addAnswer.length < 4
                  ? addAnswerHandler(callValue)
                  : null;
              }}
            >
              <span>+</span> افزودن پاسخ جدید
            </button>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default Multicoice;
